<template>
  <div class="navButton">
    <button @click="navigateToMiniProgramPage">前往小程序支付</button>
  </div>
</template>
<script src="http://res2.wx.qq.com/open/js/jweixin-1.6.0.js"></script>

<script>
import { Toast } from "cube-ui";
export default {
  name: "MyApp",
  data() {
    return {
      path: null, // 小程序页面路径
      order_sn: null,
      isShowHint: false,
    };
  },
  mounted() {
    this.loadWeChatSDK();
    // this.order_sn = "123456789";
    this.order_sn = this.$route.query.order_sn;
    this.path = `/pages/cart/payment/thirdPartyOrder?recharge_sn=${this.order_sn}`;
  },
  methods: {
    loadWeChatSDK() {
      const script = document.createElement("script");
      script.src = "https://res.wx.qq.com/open/js/jweixin-1.6.0.js"; // 微信SDK地址
      script.onload = () => {
        this.wx_loaded = true;

        // 检查是否加载成功
        if (typeof wx !== "undefined") {
          console.log("微信 SDK 加载成功");

          this.navigateToMiniProgramPage()
        } else {
          console.error("微信 SDK 加载失败");
        }
      };
      script.onerror = () => {
        console.error("微信 SDK 加载失败");
      };
      document.head.appendChild(script);
    },

    navigateToMiniProgramPage() {
      // 显示加载Toast并保存引用
      const loadingToast = this.showLoadingToast("正在跳转...");
      if (typeof wx === "undefined" || !wx.miniProgram) {
        console.error("微信 SDK 未正确加载或 wx.miniProgram 不可用");
        loadingToast.hide(); // 关闭加载提示
        this.showErrorToast("环境不支持跳转");
        return;
      }

      wx.miniProgram.navigateTo({
        url: this.path,
        success: (res) => {
          console.log("跳转成功", res);
          loadingToast.hide();
        },
        fail: (err) => {
          console.error("跳转失败", err);
          loadingToast.hide();
          this.showErrorToast("跳转失败");
        },
        complete: () => {
          // 确保无论如何都会关闭loading
          loadingToast.hide();
        },
      });
    },

    // 显示加载中Toast
    showLoadingToast(txt = "加载中...") {
      return Toast.$create({
        txt,
        type: "loading",
        time: 0, // 不自动关闭
        mask: true,
      }).show(); // 直接显示并返回实例
    },

    // 显示错误提示Toast
    showErrorToast(txt = "操作失败") {
      Toast.$create({
        txt,
        type: "error",
        time: 2000,
        mask: false,
      }).show();
    },

    // 使用 wx.miniProgram 功能
  },
};
</script>
<style scoped>
.navButton {
  width: 100%;
  display: flex;
}

button {
  margin: 80% 30%;
  padding: 10px 20px;
  background-color: #007aff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background-color: #0051a3;
}
</style>
